/**
 * Weighted compatibility score for universe collisions:
 *   score = 0.7 * (shared / smallerUniverse) + 0.3 * (log(shared+1) / log(IDEAL+1))
 *
 * Mirrors server/compatibility.js — kept in sync so client-side fallbacks
 * (legacy snapshots without matchPercent, share-card preview) match what
 * the server stored.
 */

export const IDEAL_SHARED_COUNT = 150;
const OVERLAP_WEIGHT = 0.7;
const DEPTH_WEIGHT = 0.3;
const DEPTH_DENOM = Math.log(IDEAL_SHARED_COUNT + 1);

export function computeCompatibilityPercent({ shared, yourCount, friendCount }) {
  const sharedN = Math.max(0, Number(shared) || 0);
  const yourN = Math.max(0, Number(yourCount) || 0);
  const friendN = Math.max(0, Number(friendCount) || 0);
  const smaller = Math.min(yourN, friendN);
  if (smaller <= 0) return 0;

  const overlap = Math.min(1, sharedN / smaller);
  const depth = Math.min(1, Math.log(sharedN + 1) / DEPTH_DENOM);
  const score = OVERLAP_WEIGHT * overlap + DEPTH_WEIGHT * depth;
  return Math.min(100, Math.max(0, Math.round(score * 100)));
}

export function getMatchTier(sharedCount) {
  const n = Number(sharedCount) || 0;
  if (n >= 100) return 'Deep Match';
  if (n >= 40) return 'Strong Match';
  if (n >= 10) return 'Solid Match';
  if (n >= 1) return 'Light Match';
  return null;
}
